<template>
    <div class="account-infos">
        <!-- 账户信息 -->
         <div class="user-title clearfix">
            <div class="fl" v-if="userInfo.is_vip==false">账户信息</div>
            <div class="fl c06" v-if="userInfo.is_vip==true">会员</div>
            <div class="fr">
                <el-button type="success" plain   @click="editInfo">修改信息</el-button>
                <el-button type="success" plain v-if="userInfo.is_vip==false"  @click="member">成为会员</el-button>
            </div>
        </div>
        <div class="content font-s12">
             <el-row>
                <el-col :span="3" class="c66">姓名：</el-col>
                <el-col :span="21" class="c99">{{userInfo.username}}</el-col>
            </el-row>
             <el-row class="pd-t-20">
                <el-col :span="3" class="c66">性别：</el-col>
                <el-col :span="21" class="c99" v-if="userInfo.sex==1">男</el-col>
                <el-col :span="21" class="c99" v-if="userInfo.sex==2">女</el-col>
            </el-row>
            <el-row class="pd-t-20">
                <el-col :span="3" class="c66">手机号：</el-col>
                <el-col :span="21" class="c99">{{userInfo.telphone}}</el-col>
            </el-row>
            <el-row class="pd-t-20">
                <el-col :span="3" class="c66">密码：</el-col>
                <el-col :span="21" class="c99">{{userInfo.password}}<span class="c06" @click="edit">修改</span></el-col>
            </el-row>
            <el-row class="pd-t-20">
                <el-col :span="3" class="c66">年龄：</el-col>
                <el-col :span="21" class="c99">{{userInfo.age}}</el-col>
            </el-row>
             <el-row class="pd-t-20">
                <el-col :span="3" class="c66">邮箱：</el-col>
                <el-col :span="21" class="c99">{{userInfo.email}}</el-col>
            </el-row>
              <el-row class="pd-t-20">
                <el-col :span="3" class="c66">职业：</el-col>
                <el-col :span="21" class="c99">{{userInfo.profession}}</el-col>
            </el-row>
              <el-row class="pd-t-20">
                <el-col :span="3" class="c66">所在城市：</el-col>
                <el-col :span="21" class="c99">{{userInfo.city}}</el-col>
            </el-row>
            <el-row class="pd-t-20">
                <!-- <el-button  plain   @click="logOut">退出登录</el-button> -->
            </el-row>
        </div>
    </div>
</template>

<script>
import { UserInfo } from "../../api/api";
import { LoginOut } from "../../api/api";

export default {
  data(){
      return{
        userInfo:{}
      }
  },
  created(){
      this.getUserInfo();
  },
  methods:{
       member(){ //成为会员
       this.$router.push({name:'userPrice'});
     },
     logOut(){
          this.$confirm('退出登录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            this.$axios.post(LoginOut,{}).then(res=>{
                if (res.data.code == 1) {
                        this.$message({
                            type: 'success',
                        message: res.data.msg
                    });
                    this.$router.push('/');
                }
                else{
                    this.$message.error(res.data.msg);
                }
          },err=>{
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });s
     },
      getUserInfo(){
          this.$axios.post(UserInfo,{}).then(res=>{
            if (res.data.code == 1) {
                this.userInfo=res.data.data;
            }
            else{
                this.$message.error(res.data.msg);
            }
          },err=>{
            this.$message.error(err.data.msg);
          });
      },
      edit(){ //修改
         sessionStorage.removeItem("username");
         this.$router.push({name:'findAccount',query:{telphone:this.userInfo.telphone}});
      },
      editInfo(){
         this.$router.push({name:'userEditInfo'});
      },
  }
}
</script>

<style lang="scss">
.account-infos{
 .content{
     padding: 30px;
     span{
         padding-left: 6px;
         cursor: pointer;
     }
 }
}
</style>
